exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-editor__editable {\n  max-height: 200px;\n}\n.ck-editor__editable > ul {\n  list-style-type: disc !important;\n}\n.ul-list-style-type > ul {\n  list-style-type: disc !important;\n}\n", ""]);

// exports
